import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class WindowResizeService {
    private readonly platformId = inject(PLATFORM_ID);
    private readonly resizeSubject = new Subject<void>();

    public readonly resize$ = this.resizeSubject.asObservable();

    constructor() {
        if (isPlatformBrowser(this.platformId)) {
            fromEvent(window, 'resize', { passive: true }).subscribe(() => this.resizeSubject.next());
        }
    }
}
